export default __webpack_public_path__ + "static/media/arduino.924d5fde.svg";